import React, { useState } from 'react';
import { classNames } from '@utils';
import { getBrand } from '@helpers/brand.utils';

// Components
import ModalCoverage from '@components/modal/ModalCoverage';
import {
  Button,
  IconCheckCircledCheckedFilled,
  IconCheckCircledUnchecked,
  Panel,
  Text,
} from '@ftdr/blueprint-components-react';
import Skeleton from 'react-loading-skeleton';
import REText from '@components/wrappedBDS/REText';
import { IsTheme, Theme } from '@app/core/featureToggle';
import { getCurrentThemeConfig } from '@app/core/theme-config';
import { Brand } from '@constants/brands';

const CardPlan = ({ isDrawerView = false, isLoading = false, ...props }) => {
  const [isModalActive, setIsModalActive] = useState(false);

  const hasValidPromo =
    props.priceWithoutPromotion != null &&
    props.price != null &&
    props.priceWithoutPromotion !== props.price;

  const priceDifference = hasValidPromo
    ? Math.round((props.priceWithoutPromotion - props.price) * 100) / 100
    : 0;

  const getTradeServiceFeeText = () => (getBrand() === Brand.HBW210) ? 'Service Fee (TSCF):' : 'Trade Service Call Fee (TSCF):';

  return (
    <Panel
      rounded={IsTheme(Theme.Ahs2024) ? 'xl' : 'md'}
      padding="none"
      borderColor="gray-500"
      border={IsTheme(Theme.Ahs2024) && props.isActive ? '1' : '0'}
    >
      <label className={classNames(['card--plan block relative h-full', props.className || ''])}>
        <input
          id={`${props.id}--radio`}
          type="radio"
          name="plan"
          value={props.heading}
          className="hidden"
          onClick={isLoading ? undefined : props.onClick}
          checked={props.checked}
        />

        <Panel
          backgroundColor="white"
          rounded={getCurrentThemeConfig().cardPlanPanelRounded}
          padding="none"
          border={getCurrentThemeConfig().cardPlanPanelBorder}
          borderColor="gray-100"
          shadow={getCurrentThemeConfig().cardPlanPanelShadow}
          className={getCurrentThemeConfig().cardPlanButtonClassName}
        >
          <div className="py-6 px-4">
            <div className="flex items-center">
              {isLoading ? (
                <Skeleton circle={true} height={16} width={16} />
              ) : props.isActive ? (
                <IconCheckCircledCheckedFilled size={24} color="interactive" />
              ) : (
                <IconCheckCircledUnchecked size={24} color="gray" />
              )}

              <REText
                id={`${props.id}--label`}
                variant={isDrawerView ? 'heading-05' : 'heading-04'}
                color="accent"
                className="relative top-px pl-2 my-0 plan-card-heading"
              >
                {isLoading ? <Skeleton width={200} /> : <>{props.heading}</>}
              </REText>
            </div>

            <div className="pt-2 px-4">
              {isLoading ? (
                <Skeleton width={160} />
              ) : (
                <Button
                  id={`${props.id}--coverage-link`}
                  variant="ghost"
                  size="small"
                  label="See All Coverage"
                  onClick={(e) => setIsModalActive(true) && e.stopPropagation()}
                />
              )}
            </div>
          </div>

          <div className="border-t border-gray-300 py-4 px-4">
            <div
              className={classNames(['flex flex-col space-y-3', isDrawerView ? 'px-2' : 'px-6'])}
            >
              {hasValidPromo && (
                <div className="card__price flex items-baseline space-x-1">
                  <Text
                    className="my-0 line-through text-gray-500"
                    id={`${props.id}--priceWithoutDiscount`}
                  >
                    {isLoading ? <Skeleton width={64} /> : <>${props.priceWithoutPromotion}</>}
                  </Text>
                </div>
              )}
              <div className="card__price flex items-baseline space-x-1">
                <REText variant="heading-05" className="my-0" id={`${props.id}--price`}>
                  {isLoading ? (
                    <Skeleton width={64} />
                  ) : (
                    <>${hasValidPromo ? props.price : (props.priceWithoutPromotion ?? props.price)}</>
                  )}
                </REText>
              </div>
              {hasValidPromo && (
                <div>
                  <REText variant="helper-text" color="error" className="my-0">
                    {isLoading ? (
                      <Skeleton width={64} />
                    ) : (
                      <>*Save ${priceDifference} off with instant discount</>
                    )}
                  </REText>
                </div>
              )}
              <div>
                 <REText variant="helper-text">
                  {isLoading ? <Skeleton width={128} /> : <>{getTradeServiceFeeText()}</>}
                </REText>
                <REText variant="helper-text" id={`${props.id}--service_fee`}>
                  {isLoading ? (
                    <Skeleton width={32} />
                  ) : (
                    <>${props.serviceFee} per service request.</>
                  )}
                </REText>
              </div>
            </div>
          </div>
        </Panel>
      </label>

      <ModalCoverage
        id={`${props.id}--modal`}
        isActive={isModalActive}
        onClose={() => setIsModalActive(false)}
        plan={props.heading}
        covered={props.details}
      />
    </Panel>
  );
};

export default CardPlan;
